// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sd-avatar{text-indent:0;width:36px}.sd-avatar.has-secondary-avatar{height:40px;margin-left:8px;margin-right:8px;position:relative;width:56px}.sd-avatar.has-secondary-avatar .primary-avatar{left:0;position:absolute;top:0}.sd-avatar .secondary-avatar{bottom:0;position:absolute;right:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
